import pathToRegexp from '../path-to-regexp';
import { ExtractRouteParams } from '.';

const cache: { [key: string]: (params: any, options: any) => string } = {};
const cacheLimit = 10000;
let cacheCount = 0;

function compilePath(path: string): (params: any, options: any) => string {
  if (cache[path]) return cache[path];

  const generator = pathToRegexp.compile(path);

  if (cacheCount < cacheLimit) {
    cache[path] = generator;
    cacheCount++;
  }

  return generator;
}

/**
 * Public API for generating a URL pathname from a path and parameters.
 */
function generatePath<S extends string>(
  path: S,
  params: ExtractRouteParams<S> = {} as ExtractRouteParams<S>
): string {
  // path is typed required (matching react-router v6) but guard undefined for untyped JS callers
  const p = (path as string | undefined) ?? '/';
  return p === '/' ? p : compilePath(p)(params, { pretty: true });
}

export default generatePath;
